import React, { Component } from "react";
import { AppContext } from "../../AppState";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { Grid, Paper } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import { withDataProvider, GET_LIST } from "react-admin";

const styles = {
  root: {
    flexGrow: 1
  },
  paper: {
    flex: "1 1 auto",
    position: "relative",
    minHeight: "12rem"
  },
  formControl: {
    minWidth: "20rem",
    padding: "1rem"
  },
  label: {
    marginLeft: "1rem",
    marginTop: "1rem"
  },
  select: {
    width: "100%"
  }
};

class CustomerSelector extends Component {
  // export class CustomerSelector extends React.PureComponent {

  componentDidMount() {
    // https://erp.laudus.cl/api/terms/get/list
    const { dataProvider } = this.props;
    dataProvider(GET_LIST, "terms/get/list")
      .then(({ data }) => {
        console.log("asdasd");
      })
      .catch(error => {
        console.error(error);
      });
  }

  render() {
    return (
      <div style={styles.root}>
        <Grid container>
          <Paper style={styles.paper}>
            <FormControl style={styles.formControl}>
              <AppContext.Consumer>
                {({ customerList, selected, handleChange }) =>
                  <div>
                    <InputLabel
                      htmlFor="client-simple"
                      style={styles.formControl}
                    >
                      Seleccione un Cliente
                    </InputLabel>
                    <Select
                      value={selected.customerId}
                      onChange={handleChange}
                      style={styles.select}
                    >
                      {customerList.map((row, i) =>
                        <MenuItem value={row.value} key={i} name={row.label}>
                          {row.label}
                        </MenuItem>
                      )}
                    </Select>
                  </div>}
              </AppContext.Consumer>
            </FormControl>
          </Paper>
        </Grid>
      </div>
    );
  }
}

export default withDataProvider(CustomerSelector);
